// @flow

import type {Action} from '../../types'
import type {GbiprojectState} from '../types'
import type {SetLoadingPayload} from '../actions/setLoading'

export function setLoadingReducer(state: GbiprojectState, action: Action<SetLoadingPayload>): GbiprojectState {

  return { 
    ...state,
    isLoading: action.payload.isLoading,
  }
}
